import { useEffect, useState } from "react";
import { Checkbox, ComboBox, DefaultButton, Dialog, DialogType, FontIcon, IComboBoxOption, IconButton, Label, PrimaryButton, Stack, TextField } from "@fluentui/react";
import styles from '../styles/pokemon.module.scss';
import { TSet, TTag } from "../constants/types";
import { title } from "process";

export interface IEditTagsProps {
    set: TSet;
    token: string;
    username: string;
    apiUrl: string;
    site: string;
    setMessage: Function;
    setError: Function;
}

const EditTags : React.FunctionComponent<IEditTagsProps> = (props : IEditTagsProps) => {
    const [tags, settags] = useState<TTag[]>([]);
    const [tagnamesCBOptions, settagnamesCBOptions] = useState<IComboBoxOption[]>([]);
    const tagtypeCBOptions : IComboBoxOption[] = [{key:"string",text:"text"},{key:"bool",text:"Ja/Nee"}];
    const [selectedTagName, setselectedTagName] = useState<string>();
    const [selectedTagType, setselectedTagType] = useState<string>();
    const [selectedTagValue, setselectedTagValue] = useState<string>();

    const [newTagName, setnewTagName] = useState<string>();
    const [newTagType, setnewTagType] = useState<string>();
    const [newTagValue, setnewTagValue] = useState<string>();

    const [newDefaultTags, setnewDefaultTags] = useState<string>();
    const [showSaveConfirm, setShowSaveConfirm] = useState<boolean>(false);

    const [showTags, setshowTags] = useState<boolean>(window.innerWidth > 950 ? true : false);

    useEffect(() => {
        if (props.set) {
            let tags : TTag[] = [];
            let tagnamesCBOptions: IComboBoxOption[] = [];

            const tagsparts = props.set.defaulttags.split('|');
            tagsparts.forEach(tagspart => {
                const tagparts = tagspart.split('$:$');
                tags.push({name: tagparts[0], type: tagparts[1], defaultValue: tagparts[2]});
                tagnamesCBOptions.push({key:tagparts[0], text:tagparts[0]});
            });

            settagnamesCBOptions(tagnamesCBOptions);
            if (tags.length > 0) {
                setselectedTagName(tags[0].name);
                setselectedTagType(tags[0].type);
                setselectedTagValue(tags[0].defaultValue);
            }
            settags(tags);
        }
    },[props.set]);

    useEffect(() => {
        setnewDefaultTags(CreateTagsString());
    },[tags,newTagName,newTagType,newTagValue])

    function onComboBoxTagNameChange(e,o,i) {
        setselectedTagName(o.key);
        tags.forEach(tag => {
            if (tag.name === o.key) {
                setselectedTagType(tag.type);
                setselectedTagValue(tag.defaultValue);
            }
        });
    }

    function onComboBoxTagTypeChange(type:string) {
        setselectedTagType(type);
        let stv: string = null;
        let btags = tags;
        btags.forEach(tag => {
            if (tag.name === selectedTagName) {
                if (tag.type !== type) {
                    tag.type = type;
                
                    props.set.defaulttags.split('|').forEach(tagspart => {
                        const tagparts = tagspart.split('$:$');
                        if (tag.name === tagparts[0] && type === tagparts[1]) {
                            stv = tagparts[2];
                        }
                    });
                } 
            }
        });
        settags(btags);
        setselectedTagValue(stv);
    }

    function addTag() {
        let buffTags = tags;
        buffTags.push({name: newTagName, type: newTagType, defaultValue: newTagValue});

        let tagnamesCBOptions: IComboBoxOption[] = [];

        buffTags.forEach(tag => {
            tagnamesCBOptions.push({key:tag.name, text:tag.name});
        });
        settagnamesCBOptions(tagnamesCBOptions);

        if (buffTags.length > 0) {
            setselectedTagName(tags[tags.length-1].name);
            setselectedTagType(tags[tags.length-1].type);
            setselectedTagValue(tags[tags.length-1].defaultValue);
        }
        settags(buffTags);

        setnewTagName("");
        setnewTagType("");
        setnewTagValue("");
    }

    function canSave() : boolean { //Getest:bool:1|Status:string:Goed|Compleet:string:Alleen game|Versie:string:EUR
        const newDefaultTags = CreateTagsString();
        
        if (newDefaultTags === props.set.defaulttags) {
            return false;
        } else {
            return true;
        }
    }

    function CreateTagsString() : string {
        let newDefaultTags : string = "";
        tags.forEach(tag => {
            if (newDefaultTags !== "") {
                newDefaultTags += "|";
            }
            newDefaultTags += tag.name+"$:$"+tag.type+"$:$"+tag.defaultValue;
        });
        
        return newDefaultTags;
    }

    function save() {
        setShowSaveConfirm(true);
    }

    function doSave(copy:boolean) {
        if (newDefaultTags) {
            let formData = new FormData();
            formData.append("defaultlwhw", props.set.defaultlwhw);
            formData.append("defaulttags", newDefaultTags);
            formData.append("id", props.set.id.toString());
            formData.append("name", props.set.name);
            formData.append("parentid", props.set.parentid ? props.set.parentid.toString() : '0');
            formData.append("token",props.token);
            formData.append("username",props.username);
            formData.append("site",props.site);
            fetch(`${props.apiUrl}/UpdateSet`, {
                method: "Put",
                mode: "cors",
                referrerPolicy: "origin-when-cross-origin",
                body: formData
                }).then((response) => response.json()).then((data: number) => {
                    props.setMessage("Standaard product eigenschappen opgeslagen in set");
                    if (copy) {
                        let formData2 = new FormData();
                        formData2.append("setid", props.set.id.toString());
                        formData2.append("token",props.token);
                        formData2.append("username",props.username);
                        formData2.append("site",props.site);
                        formData2.append("tags", newDefaultTags);
                        fetch(`${props.apiUrl}/PushTags`, {
                            method: "Put",
                            mode: "cors",
                            referrerPolicy: "origin-when-cross-origin",
                            body: formData2
                        }).then((response) => response.json()).then((data: number) => {
                            props.setMessage(data+" producten aangepast met nieuwe tags");
                            setShowSaveConfirm(false);
                        }).catch(err => {
                            console.log(err);
                            props.setError("Fout tijdens opslaan van tags in producten. "+err);
                        });
                    }
                }).catch(err => {
                    console.log(err);
                    props.setError("Fout tijdens opslaan van standaard product eigenschappen. "+err);
                });     
        }       
    }

    function deleteTag() {
        let buffTags : TTag[] = [];
        
        tags.forEach(t => {
            if (t.name !== selectedTagName) {
                buffTags.push(t);
            }
        });

        let tagnamesCBOptions: IComboBoxOption[] = [];

        buffTags.forEach(tag => {
            tagnamesCBOptions.push({key:tag.name, text:tag.name});
        });
        settagnamesCBOptions(tagnamesCBOptions);

        if (buffTags.length > 0) {
            setselectedTagName(tags[tags.length-1].name);
            setselectedTagType(tags[tags.length-1].type);
            setselectedTagValue(tags[tags.length-1].defaultValue);
        }
        settags(buffTags);
    }

    return (
        props.set ?
        <Stack style={{marginLeft:0, display: window.innerWidth > 950 ? "flex":"block"}}>
            <Dialog
                hidden={!showSaveConfirm}
                dialogContentProps={{ type: DialogType.normal }}
                onDismiss={() => { setShowSaveConfirm(false); }}
                modalProps={{ styles: { main: { maxHeight: "100%!important", width: 800, height: 800, maxWidth: "100%!important", backgroundColor: "transparent", boxShadow: "none", overflowY: "auto" } } }}
            >
                <Stack horizontalAlign='center' style={{backgroundColor:"white",padding:20}}>
                    <Label>Weet u zeker dat u wilt opslaan?</Label>
                    <br/>
                    <table>
                        <tr>
                            <td>
                                <DefaultButton autoFocus style={{margin:5, width:"100%"}} text="Niet opslaan" onClick={() => { setShowSaveConfirm(false); }} />
                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td>
                                <PrimaryButton style={{margin:5, width:"100%"}} text="Tags updaten" onClick={() => { doSave(false); }} />
                            </td>
                            <td>
                                <Stack horizontal verticalAlign="center">
                                    <Label style={{marginLeft:5}}>De standaard tags worden beschikbaar bij het toevoegen van nieuwe producten.</Label>
                                </Stack>        
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <DefaultButton style={{margin:5, width:"100%", backgroundColor: '#f00', color:"white" }} text="Tags toevoegen" onClick={() => { doSave(true); }} />
                            </td>
                            <td>
                                <Stack horizontal verticalAlign="center">
                                    <Label style={{marginLeft:5}}>ALLE producten van de set worden geupdate met nieuwe tags. Verwijderde tags worden van de producten verwijderd.</Label>
                                </Stack>            
                            </td>
                        </tr>
                    </table>
                </Stack>
            </Dialog>
            <Stack style={{height:"100%", margin:5, border:"1px solid blue", padding: 5}} >
                <Stack horizontal onClick={() => {setshowTags(!showTags)}} verticalAlign='center' >
                    <IconButton iconProps={{iconName: showTags ? 'Hide' : "View"}} />
                    &nbsp;
                    <Label style={{fontWeight:"bold", cursor:"pointer"}}>Nieuwe standaard tag</Label>
                </Stack>
                {showTags && <Stack horizontalAlign='start' style={{width:"100%"}}>
                                <TextField label={"Titel"} value={newTagName} styles={{root: {width: '100%'}}} onChange={(e,v) => {setnewTagName(v);}}/>
                                <ComboBox label={"Type"} style={{width:"100%"}} styles={{root: {width: '100%'}}} options={tagtypeCBOptions} selectedKey={newTagType} onChange={(e,o,i) => { setnewTagType(o.key.toString());}} />
                                <Stack horizontal verticalAlign="end" horizontalAlign="end" style={{width:'100%'}}>
                                    {newTagType === "string" ? <TextField label={"Standaard waarde"} style={{width:"100%"}} value={newTagValue} onChange={(e,v) => {setnewTagValue(v);}} />
                                                            : <Stack style={{width:'100%'}}>
                                                                    <Label>Standaard waarde</Label>
                                                                    <Checkbox checked={newTagValue === "1" ? true : false} 
                                                                            label={newTagValue === "1" ? "Ja" : "Nee"} 
                                                                            onChange={(e,c) => { setnewTagValue(c?"1":"0");}} />
                                                             </Stack>}
                                    <PrimaryButton disabled={newTagName && newTagType ? false : true} text="Toevoegen" style={{marginLeft:10}} onClick={addTag}/>
                                </Stack>
                            </Stack>}
                <hr />
                <Stack horizontal verticalAlign='center'>
                    <Label style={{fontWeight:"bold", cursor:"pointer"}}>Tags</Label>
                </Stack>
                {showTags && <Stack horizontalAlign='start'>
                                <Stack horizontal verticalAlign="end">
                                    <ComboBox label={"Titel"} options={tagnamesCBOptions} styles={{root:{width:"100%"}}} selectedKey={selectedTagName} onChange={onComboBoxTagNameChange} />
                                    <FontIcon iconName="Trash" className={styles.deleteMedium} onClick={deleteTag} />
                                </Stack>
                                <ComboBox label={"Type"} styles={{root:{width:"100%"}}} options={tagtypeCBOptions} selectedKey={selectedTagType} onChange={(e,o,i) => { onComboBoxTagTypeChange(o.key.toString()); }} />
                                <Stack horizontal verticalAlign="end" style={{width:"100%"}}>
                                    {selectedTagType === "string" ? <TextField label={"Standaard waarde"} value={selectedTagValue} onChange={(e,v) => {setselectedTagValue(v);}} />
                                                                : <Stack>
                                                                        <Label>Standaard waarde</Label>
                                                                        <Checkbox checked={selectedTagValue === "1" ? true : false} 
                                                                                label={selectedTagValue === "1" ? "Ja" : "Nee"} 
                                                                                onChange={(e,c) => { setselectedTagValue(c?"1":"0");}} />
                                                                    </Stack>}
                                    <PrimaryButton disabled={!canSave()} text="Opslaan" style={{marginLeft:10}} onClick={save} />
                                </Stack>
                            </Stack>}
            </Stack>
        </Stack>
        : <></>
    );
}

export default EditTags;